import React, { Component } from 'react';

import Dashbar from './Dashbar';

class Loadash extends Component {
  
  render() {
    return(
      <div>
      <Dashbar/>
      <div className="grid placeholder">
        <div className="category">
          <h2>Recommended</h2>
        </div>
        {[...Array(24)].map((e, i) => {
          return <li key={i}><a><div className="empty"></div><h5 className="title"> </h5></a></li>
        })}
      </div>
      </div>
    );
  }
}

export default Loadash;


// WEBPACK FOOTER //
// ./src/components/Loadash.js